// inquiry-renderer/src/api.js

const clientKey = "D0FC2C05-0BD0-409F-B350-6AF719A33F88";
const formId = "2266";
const appKey = "23697F14-AA8C-4622-9F64-FC1A9FF20D0D";

export const submitToCaterease = async (formData) => {
  const BASE_URL = `https://api-cec.catereasewebtools.com/inbound-inquiries`;

  console.log("Submitting to secure API endpoint...");

  return fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'appkey': appKey,
      'clientkey': clientKey,
      'formid': formId
    },
    body: JSON.stringify(formData)
  });
};